import { useMethods } from '@lhb/hook';
import { CSSProperties, FC, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import IconFont from '@/common/components/IconFont';
import styles from './index.module.less';
import cs from 'classnames';
import { message } from 'antd';
import { useBigdataFn } from '@/common/utils/bigdata';
import MakeMarker from './MakeMarker';
// // import { bigdataBtn } from '@/common/utils/bigdata';
/** 点标记
 * 地址解析
 * 根据点击的经纬度获取对应的地址
 */
const GetAddress: FC<{
  _mapIns?: any;
  style?: CSSProperties;
  className?: string;
  clearClickEvent: Function;
  addClickEvent: Function;
  URLParamsRef?:any;
  setTargetOperation?: Function;
  targetOperation?: String;
  setSelected:any
  // isCheckInsideMapOperate?:boolean;
  isCheckOutsideMapOperate?:boolean;
  setIsCheckInsideMapOperate?:Function;
  setIsCheckOutsideMapOperate?:Function;
  getAddressEventId?:string;
  beforeCheckFn?: (geoResult) => Promise<boolean>;
  ref?: any;
}> = forwardRef(({
  _mapIns,
  style,
  className,
  clearClickEvent,
  addClickEvent,
  URLParamsRef,
  targetOperation,
  setTargetOperation,
  setSelected,
  // isCheckInsideMapOperate,
  isCheckOutsideMapOperate,
  setIsCheckInsideMapOperate,
  setIsCheckOutsideMapOperate,
  getAddressEventId,
  beforeCheckFn
}, ref) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const labelMarkerRef = useRef<any>(null);
  const [geocoderIns, setGeocoderIns] = useState<any>(null);
  const [groupIns, setGroupIns] = useState<any>(null);
  const [status, setStatus] = useState<boolean>(false);
  const makeMarkerRef: any = useRef();
  useEffect(() => {
    if (!_mapIns) return;
    if (!window?.AMap?.Geocoder) {
      throw new Error('AMap.Geocoder 未引入！');
    }
    const geocoder = new window.AMap.Geocoder({});
    setGeocoderIns(geocoder);
    const group = new window.AMap.OverlayGroup();
    _mapIns.add(group);
    setGroupIns(group);
    labelMarkerRef.current = new window.AMap.Marker({
      content: ' ',
      map: _mapIns,
      anchor: 'top-left',
      offset: [-34, 6]
    });
    // _mapIns.on('click', regeoCode);
    // return () => {
    //   _mapIns.off('click', regeoCode);
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_mapIns]);

  useEffect(() => {
    // 点标记时
    if (targetOperation && targetOperation === 'ruler') {
      _mapIns.off('click', regeoCode);
      setStatus(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetOperation]);
  useEffect(() => {
    if (isCheckOutsideMapOperate) {
      setStatus(false);
      setSelected((state) => (state === 0 ? 0 : state - 1));
      addClickEvent && addClickEvent();
      _mapIns.off('click', regeoCode);
    }
  }, [isCheckOutsideMapOperate]);
  const {
    onClickBtn,
    regeoCode,
    clear,
    // clickMarker
  } = useMethods({
    clear() {
      // setIsCheckOutsideMapOperate?.(true);
      setIsCheckInsideMapOperate?.(false);
      setStatus(false);
      setSelected((state) => (state === 0 ? 0 : state - 1));
      addClickEvent && addClickEvent();
      _mapIns.off('click', regeoCode);
      // 清空所有的点位
      // groupIns && groupIns.clearOverlays();
      // groupIns && groupIns.hide();
      setTargetOperation && setTargetOperation('');
    },
    onClickBtn: () => {
      if (status) {
        clear();
        setTargetOperation && setTargetOperation('');
      } else {
        // if (URLParamsRef) {
        //   URLParamsRef.current.pushpinInfo = [];
        // }
        setIsCheckOutsideMapOperate?.(false);
        setIsCheckInsideMapOperate?.(true);

        setStatus(true);
        setSelected((state) => state + 1);
        _mapIns && _mapIns.on('click', regeoCode);
        clearClickEvent && clearClickEvent();
        groupIns && groupIns.show();
        setTargetOperation && setTargetOperation('dotMark');
      }

    },
    regeoCode: (e) => {
      if (getAddressEventId) {
        // // bigdataBtn(getAddressEventId, '', '工具箱-标记	', '点击了工具箱标记');
        bigdataFn(getAddressEventId, '工具箱-标记', '点击了工具箱标记', { op_block: '工具箱', op_event: ``, });
      }
      // if (!status) return;
      if (URLParamsRef?.current?.pushpinInfo?.length >= 10) {
        message.error('标记最多十个！'); return;
      }
      const { lnglat } = e;
      geocoderIns.getAddress(lnglat, async (statusCode, result) => {
        // URLParamsRef.current.pushpinInfo 默认值为空数组[]
        // 新版标记覆盖物
        if (statusCode === 'complete' && result.regeocode) {
          const address = result.regeocode.formattedAddress;
          let allow = true;
          if (beforeCheckFn) {
            allow = await beforeCheckFn(result);
          }
          if (!allow) {
            return;
          }
          if (makeMarkerRef.current) {
            makeMarkerRef.current.createMarker({ // 从下面的代码提上来的
              position: lnglat,
              anchor: 'bottom-center',
              offset: [6, 0],
              bubble: true, // 允许冒泡
              // zIndex: toolOpen ? toolSpecialOpenZIndex.markAddress : layerBaseZIndex.markAddress,
            }, address);
            return;
          }

          // 判断是否包含台湾省信息

          if (URLParamsRef) {
            URLParamsRef.current.pushpinInfo = [...URLParamsRef.current.pushpinInfo, { lnglat, address }];
            if (Number(result.regeocode.addressComponent.adcode) === 710000) {
              URLParamsRef.current.limit += 1;
            }
          }
          const content = `<svg style='width: 26px; height: 26px;' aria-hidden><use xlink:href='#iconic_biaoji'/></svg>`;
          const marker = new window.AMap.Marker({
            content,
            position: lnglat,
            anchor: 'bottom-center',
          });
          // amapGetAddressSignLabel 通过 src/common/styles/amap.less 引入样式
          const labelContent = `<div class='amapGetAddressSignLabel'>${address}
          <svg style='width: 9px; height: 9px;' aria-hidden>
          <use xlink:href='#iconic_close_colour_seven' style='fill:#132144 '/>
          </svg>
          </div>`;
          const labelMarker = new window.AMap.Marker({
            content: labelContent,
            position: lnglat,
            anchor: 'top-left',
          });
          // 标记点关闭按钮
          labelMarker.on('click', (e) => {
            // 判断点中的是关闭按钮
            if (e.originEvent?.target?.nodeName === 'svg') {
              const arr:any = [];
              if (URLParamsRef) {
                URLParamsRef.current.pushpinInfo.map((item) => {
                  if (item.lnglat !== lnglat) {
                    arr.push({ lnglat: item.lnglat, address: item.address });
                  }
                });
                URLParamsRef.current.pushpinInfo = arr;
                if (Number(result.regeocode.addressComponent.adcode) === 710000) {
                  URLParamsRef.current.limit -= 1;
                }
              }
              groupIns?.removeOverlay(marker);
              groupIns?.removeOverlay(labelMarker);
            }
          });
          groupIns?.addOverlay(marker);
          groupIns?.addOverlay(labelMarker);
        } else {
          message.warning('根据经纬度查询地址失败');
        }
      });

    },
    clickMarker: (e) => {
      groupIns && groupIns.removeOverlay(e);
    }
  });

  useImperativeHandle(ref, () => ({
    clear
  }));
  return <><div
    className={
      cs(styles.satellite,
        className,
        'bg-fff pointer selectNone',
        status && styles.satelliteSelected
      )
    }
    onClick={onClickBtn}
    style={style} >
    <div className={
      cs(status && styles.satelliteConSelected)
    }>
      <IconFont
        iconHref='iconic_biaoji1'
        style={{ width: '16px', height: '16px' }} />
      {/* <span className='inline-block ml-5'>{status && '清除'}标记</span> */}
      <span className='inline-block ml-5 c-222'>标记</span>
    </div>
  </div>

  <MakeMarker
    ref={makeMarkerRef}
    mapIns={_mapIns}
    geocoderIns={geocoderIns}
  />
  </>;
});

export default GetAddress;
